var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPenHighlightLarge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.942501 3.84789L4.6175 7.81728C5.3225 8.57876 6.275 9 7.2725 9L20.735 9C21.7325 9 22.685 8.57066 23.39 7.81728L27.0575 3.84788C27.3425 3.54005 27.5 3.13501 27.5 2.70567V0L0.5 2.36042e-06V2.69757C0.5 3.12691 0.657501 3.54006 0.942501 3.83979V3.84789ZM9.5 28.9442V20.0546C9.5 19.4721 9.94771 19 10.5 19H17.5C18.0523 19 18.5 19.4721 18.5 20.0545V25.4993C18.5 25.909 18.275 26.2817 17.9229 26.4549L10.9229 29.8998C10.2599 30.2261 9.5 29.7157 9.5 28.9442ZM20.25 11L7.75 11C7.05964 11 6.5 11.8954 6.5 13L6.5 15C6.5 16.1046 7.05964 17 7.75 17L20.25 17C20.9404 17 21.5 16.1046 21.5 15V13C21.5 11.8954 20.9404 11 20.25 11Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenHighlightLarge);
export default __webpack_public_path__ + "static/media/pen-highlight-large.f455d35c42d3eb5d9e66482dd50bd600.svg";
export { ForwardRef as ReactComponent };